import { useSelector } from 'react-redux';
import DroppableDummySection from './DroppableDummySection';
import useEffectiveLayoutPadding from 'EmailEditorUI/hooks/styleSettings/useEffectiveLayoutPadding';
// @ts-expect-error no declarations found for module
import { LAYOUT_PADDING } from 'EmailEditorUI/utils/styleUtils';
import { getIsFileManagerOpen } from 'LayoutBuilderUI/selectors/userInterface';
import { jsx as _jsx } from "react/jsx-runtime";
const DND_SPACING = 85;
function FooterSection({
  lastSection,
  numSections
}) {
  const {
    bottom: paddingBottom
  } = useEffectiveLayoutPadding();
  const isFileManagerOpen = useSelector(getIsFileManagerOpen);
  // Allow at least 85px of padding on bottom at all times
  const paddingWitDndSpacingOffset = Math.max(DND_SPACING, paddingBottom + DND_SPACING - LAYOUT_PADDING.DEFAULT_Y);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(DroppableDummySection, {
      style: {
        paddingBottom: `${paddingWitDndSpacingOffset}px`
      },
      sectionForDrop: lastSection,
      sectionIndexForDrop: numSections - 1,
      dropAtStartOfEmail: false,
      numSections: numSections,
      id: "footer",
      isFileManagerOpen: isFileManagerOpen
    })
  );
}
export default FooterSection;